<!-- Não Confirmado -->
<sgt-pedido-status-badge-nao-confirmado
    *ngIf="isNaoConfirmado()">
</sgt-pedido-status-badge-nao-confirmado>

<!-- Não Liberado -->
<sgt-pedido-status-badge-nao-liberado
    *ngIf="isNaoLiberado()">
</sgt-pedido-status-badge-nao-liberado>

<!-- Confirmado -->
<sgt-pedido-status-badge-confirmado
    *ngIf="isConfirmado()">
</sgt-pedido-status-badge-confirmado>

<!-- Confirmando ERP -->
<sgt-pedido-status-badge-confirmando-erp
    *ngIf="isConfirmandoERP()">
</sgt-pedido-status-badge-confirmando-erp>

<!-- Aberto ERP -->
<sgt-pedido-status-badge-aberto-erp
    *ngIf="isAbertoERP()">
</sgt-pedido-status-badge-aberto-erp>

<!-- Em Análise -->
<sgt-pedido-status-badge-em-analise
    *ngIf="isEmAnalise()">
</sgt-pedido-status-badge-em-analise>

<!-- Aprovado -->
<sgt-pedido-status-badge-aprovado
    *ngIf="isAprovado()">
</sgt-pedido-status-badge-aprovado>

<!-- Reprovado -->
<sgt-pedido-status-badge-reprovado
    *ngIf="isReprovado()">
</sgt-pedido-status-badge-reprovado>

<!-- Produção -->
<sgt-pedido-status-badge-producao
    *ngIf="isProducao()">
</sgt-pedido-status-badge-producao>

<!-- Faturado -->
<sgt-pedido-status-badge-faturado
    *ngIf="isFaturado()">
</sgt-pedido-status-badge-faturado>

<!-- Faturado Parcial -->
<sgt-pedido-status-badge-faturado-parcial
    *ngIf="isFaturadoParcial()">
</sgt-pedido-status-badge-faturado-parcial>

<!-- Cancelado -->
<sgt-pedido-status-badge-cancelado
    *ngIf="isCancelado()">
</sgt-pedido-status-badge-cancelado>

<!-- Revisao -->
<sgt-pedido-status-badge-revisao
    *ngIf="isRevisao()">
</sgt-pedido-status-badge-revisao>

<!-- Outro -->
<sgt-pedido-status-badge-outro
    *ngIf="isOutro()">
</sgt-pedido-status-badge-outro>